export default "__VITE_ASSET__xPl9OSFs__"